import React, { type ButtonHTMLAttributes } from 'react'

type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  loading?: boolean
  className?: string
}

export const Button: React.FC<ButtonProps> = ({ children, loading, className,...rest }) => (
  <button className={`${className} bg-white text-xs rounded-xl p-2 hover:bg-white/80`} type='button' {...rest}>
    {loading ? 'Carregando...' : children}
  </button>
)